/** @format */
import { css } from 'styled-components';

import { FilterResultsSummaryProps } from './types';

/**
 * Base styles for the filter results summary component
 *
 * @param {FilterResultsSummaryProps} props The filter results summary properties object
 * */
const baseStyles = (props: FilterResultsSummaryProps) => css`
    display: flex;
    align-items: center;

    .filter-results-link {
        flex-shrink: 0;
        align-self: flex-start;
        margin: 2.4rem 0 1.6rem 0.4rem;
    }
`;

/**
 * The filter results summary component styles
 *
 * @param {FilterResultsSummaryProps} props The filter results summary properties object
 * */
export const styles = (props: FilterResultsSummaryProps) => css`
    ${baseStyles(props)}
`;
